'use strict';

namespace Core {

    class ModalCancellationsBasketDetails {
        show: boolean;
        public cancellationData;
        public isCancellationReady = false;

        constructor(
            private $scope: ng.IScope,
            private broker: any,
            )
        {
        }

        init (container : ng.IAugmentedJQuery) {
            this.broker.subscribe('modalCancellationsBasketDetails', 'showModalCancellationsBasketDetails', e => {
                this.show = true;
                if (TRPCONFIG.Domain.BrandedFareCancellations) {
                    this.cancellationData = TRPCONFIG.Domain.BrandedFareCancellations.CancellationChargeEvents;
                }
                else if (sessionStorage.getItem('BrandedFareCancellations') !== null) {
                    const BrandedFareCancellations =
                        JSON.parse(sessionStorage.getItem('BrandedFareCancellations') || '');
                    this.cancellationData = BrandedFareCancellations.CancellationChargeEvents;
                }

                this.formatEventName(this.cancellationData);
            });

            this.$scope.$on('$destroy', () => {
                this.broker.unsubscribe('modalCancellationsBasketDetails');
            });
        }

        formatEventName(data) {
            for (let i = 0; i < data.length; i++) {
                let eventType = data[i].EventTypes;
                for (let j = 0; j < eventType.length; j++) {
                    let chargeName = data[i].EventTypes[j];
                    chargeName = chargeName.replace(/([A-Z])/g, ' $1').trim();
                    data[i].EventTypes[j] = chargeName;
                }
            }
        }
    }

    angular
        .module('core')
        .directive('modalCancellationsBasketDetails', (): ng.IDirective => {

            return {
                scope: {},
                controller: ModalCancellationsBasketDetails,
                controllerAs: 'mcbd',
                templateUrl: 'partials/home/directivetemplate?type=CancellationsBasketDetails',
                link: function (
                    scope : ng.IScope,
                    el : ng.IAugmentedJQuery,
                    attr,
                    controller : ModalCancellationsBasketDetails) {
                    controller.init(el);
                }
            };
    });

}
